import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IHealthStatus } from '@app/app.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceService {
  constructor(private readonly http: HttpClient) {}

  public getHealthStatus(): Observable<IHealthStatus> {
    return this.http.get<IHealthStatus>('health');
  }
}
